import React from 'react';
import { ModuleBridge } from '../components';

export const MigrationDetails = () => {
    return <ModuleBridge moduleId="migration_details_main" />;
};
